<template>
<!-- :width="window.innerWidth"
    :height="window.innerHeight"
    :minWidth="1300"
    :minHieght="670" -->
  <div
    class="exportSceneList"
    @keydown.stop
  >
    <div class="container" v-show="visible" :style="{width: Window_Size.width + 'px', height: Window_Size.height + 'px', overflow: 'auto'}">
      <div class="header">
        <span>设置导出场景信息</span>
        <div class="close-btn" @click="closeDialog"></div>
      </div>
      <div class="line"></div>
      <div class="content">
        <div class="export-scene-wrapper" v-for="(scene, i) in TOOL.sprites" :key="i">
          <export-scene ref="exportScene"
            :scene="scene"
          ></export-scene>
        </div>
      </div>
      <div class="line"></div>
      <div class="footer">
        <div class="submit-btn" :class="{'is-disabled': !submitReady}" @click="submit()">提交审核</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import exportScene from './exportScene.vue'
import domtoimage from '../../../plugins/dom-to-image';
import setBlobImageSize from '../../../plugins/setBlobImageSize';

function sequenceTasks(tasks) {
  function recordValue(results, value) {
    results.push(value);
    return results;
  }
  var pushValue = recordValue.bind(null, []);
  return tasks.reduce(function (promise, task) {
    return promise.then(task).then(pushValue);
  }, Promise.resolve());
}

function seq (tasks, vm) {
  sequenceTasks(tasks)
    .then(arr => {
      vm.submitReady = true;
    })
    .catch(err => {
      setTimeout(() => {
        vm.submitReady = true;
      }, 10000);
    })
}

export default {
  components: {
    exportScene
  },
  props: {
    visible: Boolean,
  },
  data () {
    return {
      containerSize: {
        w: 0,
        h: 0,
      },
      resizeHandler: () => {},
      window: window,
      catesDict: {},
      catesDictVertical: {},
      submitReady: false,
    }
  },
  computed: {
    ...mapGetters([
      'Window_Size',
      'TOOL',
      'StyleArrayMsg',
      'StyleDataMsg',
    ]),
    containerStyle () {
      return {
        width: this.containerSize.w + 'px',
        height: this.containerSize.h + 'px'
      }
    },
  },
  watch: {
    visible: {
      handler (val) {
        const vm = this;
        let tasks = [];
        this.submitReady = false;
        if (val) {
          let vertical = this.TOOL.optimized === 'Vertical';
          let catesDict = vertical ? this.catesDictVertical : this.catesDict;
          let keyArr = Object.keys(catesDict);

          if (keyArr && !keyArr.length) {
            this.getCatesDict()
              .then((arr) => {
                [].concat(this.$refs.exportScene).forEach((item) => {
                  catesDict = vertical ? this.catesDictVertical : this.catesDict;
                  item.init();
                  item.initCateItems(catesDict);
                  tasks.push(() => {
                    return item.getSnaps();
                  });
                });

                seq(tasks, vm);
              });
          }

          if (keyArr && keyArr.length) {
            [].concat(this.$refs.exportScene).forEach((item) => {
              item.init();
              item.initCateItems(catesDict);
              tasks.push(() => {
                return item.getSnaps();
              });

              // item.initCateItems(vertical ? this.catesDictVertical : this.catesDict);
            });
            seq(tasks, vm);
          }

        }
      }
    },

    // StyleArrayMsg: {
    //   handler (val, oldVal) {
    //     if (val.length && !oldVal.lenght) {

    //     }
    //   }
    // },

    // visible: {
    //   handler (val) {
    //     if (val) {
    //       this.getCatesDict()
    //         .then((arr) => {
    //           [].concat(this.$refs.exportScene).forEach((item) => {
    //             item.initCateItems(this.catesDict);
    //           })
    //         })
    //     }
    //   }
    // }
  },
  created () {
    // this.resizeHandler = this.assignSize.bind(this);
    // $(window).on('resize', this.resizeHandler);

    this.$bus.on('exportScene.toggleRemoved', () => {
      let list = [].concat(this.$refs.exportScene);
      if (list.length) {
        let remain = list.filter((item) => {
          return !item.isRemoved
        });
        list.forEach(item => {
          item.toggleDR(remain.length === 1);
        });
      }
    });
  },
  // beforeDestroy () {
  //   $(window).off('resize', this.resizeHandler);
  // },
  methods: {
    beforeOpen () {
      // this.assignSize();
    },
    assignSize () {
      this.containerSize = {
        w: window.innerWidth,
        h: window.innerHeight
      }
    },
    closeDialog () {
      this.$store.commit('save_TopnavMsg', {
        isShowExportSceneList: false
      });
    },

    getCatesDict () {
      this.catesDict = {};
      this.catesDictVertical = {};
      this.StyleArrayMsg

      let task = this.StyleArrayMsg.map((v) => {
        return this.getCates(v.id)
      });

      let taskVertical = this.StyleArrayMsg.map((v) => {
        return this.getCates(v.id, true)
      });

      return Promise.all([...task, ...taskVertical]);
    },
    getCates (styleId, vertical) {
      return this.$http.get('/api/home/category', {
        params: {
            type: 12,
            style: styleId,
            direction: vertical ? 2 : 1
        }
      }).then((res) => {
        if (vertical) {
          this.catesDictVertical[styleId] = res.data.data;
          return;
        }
        this.catesDict[styleId] = res.data.data;
      })
    },

    submit () {
      if (!this.submitReady) {
        return;
      }
      this.submitReady = false;

      let tasks = [];
      let list = [].concat(this.$refs.exportScene);
      let scenes = this.TOOL.toJson().scenes || [];
      list.forEach((item, i) => {
        if (item.isRemoved) {
          return;
        }

        let task = item.submit(scenes[i]);
        tasks.push(task);
      });

      Promise.all(tasks)
        .then(arr => {
          this.closeDialog();
          this.$message({
            type: 'success',
            message: '导出场景页成功，请耐心等待审核'
          });
        })
        .catch(err => {
          if (err.message.indexOf('__') === 0) {
            this.$message({
              type: 'error',
              message: err.message.replace('__', '')
            });
          } else {
            this.$message({
              type: 'error',
              message: '导出场景页失败，请稍后重试'
            });
          }
          this.submitReady = true;
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  background-color: #fff;
}

.line {
  width: 1200px;
	height: 1px;
	background-color: #eaeaf4;
  margin: auto;
}

.header {
  position: relative;
  width: 1200px;
  margin: auto;
  padding-top: 90px;
  padding-bottom: 40px;
}

.close-btn {
  float: right;
  width: 21px;
	height: 21px;
	background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABJklEQVQ4jZXUO0oDQQAG4C+DRVBPYG+Tyk4sfOGLBDyDWIgKFt7BOwgBG48giKJCBLUwhZa5iM/SYnYhbjazmx+m2NnZD3b+2W2cnpzN4QIbGOAYr+plCeeYRw9HU7jEZrZgAQ/o4LkCW8EtprPrXTQD1gsLZ3GD5QmwPGtBfM1iUug4DAYBB/iqiaawTxwG9MU9q0KrsDb6IZt4qkDvcVeBvUAYupFCm9lIYkUwR9tj0EqsDCSevzZ+E9hPGTYOTM3naWSj1oOrYrNle5anKTY+ck6LYI6VtVnMTBk6DKawb+V7OoLmYAr7wA62lbf/Dw3iLyiFdcQ28/ZT6GJAtwaWpwrtBrRqYnXQVsDjBFgV2gvYw7XY4pu4+SlsGN3Cu/gZXmH/D/UGVown20uZAAAAAElFTkSuQmCC');
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
}
.content {
  width: 1200px;
  margin: auto;
}
.export-scene-wrapper {
  margin-bottom: 70px;

  &:first-child {
    margin-top: 70px;
  }
}

.footer {
  display: flex;
  justify-content: center;
  padding-top: 50px;
  padding-bottom: 158px;
}

.submit-btn {
  width: 160px;
	height: 40px;
  line-height: 40px;
	background-color: #5778fb;
	border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  text-align: center;

  &.is-disabled {
    opacity: .5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/exportSceneList.vue